import { render, staticRenderFns } from "./StandardCheckBox.vue?vue&type=template&id=b97a726c&scoped=true"
import script from "./StandardCheckBox.vue?vue&type=script&lang=js"
export * from "./StandardCheckBox.vue?vue&type=script&lang=js"
import style0 from "./StandardCheckBox.vue?vue&type=style&index=0&id=b97a726c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97a726c",
  null
  
)

export default component.exports